
import * as constants from "../Constatnts";
import axios from "axios";



export function getMachineDashboardCount(stores) {
  return async (dispatch, getState) => {
    try {
      const token = getState().user.uat;

      const response = await axios.get(
        `${constants.API_URL}/reports/machinedashboard`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          params: {
            stores: JSON.stringify(stores)
          },
        }
      );

      return response.data;
    } catch (error) {
      console.error("API Error:", error);
      throw error;
    }
  };
}


export function getMachineLedger(id) {
  return async (dispatch, getState) => {
    try {
      const token = getState().user.uat;

      const response = await axios.get(
        `${constants.API_URL}/inventory/report/machineledger/${id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      return response.data.data;
    } catch (error) {
      console.error("API Error:", error);
      throw error;
    }
  };
}

export function getMachineServicesById(id) {
  return async (dispatch, getState) => {
    try {
      const token = getState().user.uat;

      const response = await axios.get(
        `${constants.API_URL}/inventory/report/machineservicesbyid/${id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      return response.data.data;
    } catch (error) {
      console.error("API Error:", error);
      throw error;
    }
  };
}
export function getUniqueNoInstock(stores) {
  return async (dispatch, getState) => {
    try {
      const token = getState().user.uat;

      const response = await axios.get(
        `${constants.API_URL}/transaction/inventory/uniquenoinstock`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          params: {
             stores: JSON.stringify(stores)
          },
        }
      );

      return response.data;
    } catch (error) {
      console.error("API Error:", error);
      throw error;
    }
  };
}